import React from 'react';
import { Tab } from 'baseui/tabs-motion';
import { IDummyProps } from './types';
import { withPermissionsProps } from '../../Utilities/hoc/withPermissions';
import { FunctionalRenderedLink } from '../Link';
import { tabBaseStyles } from './styles';

type EpoType = IDummyProps & withPermissionsProps;

//TODO: remove/refactor this component tab-motion render issue without tabs */
export const View = React.forwardRef((props: EpoType, ref: any) => {
	const { children, ...rest } = props;
	return (
		<Tab
			{...rest}
			// ref={ref}  // TODO : not accepted review on the next version
			overrides={{
				Tab: {
					style: () => {
						return {
							...tabBaseStyles,
							backgroundColor: 'red !important',
						};
					},
					// TODO: not working in the current BaseWeb version
					// once it is done remove styles.scss
					component: FunctionalRenderedLink,
				},
			}}
		>
			{props.allowed ? children : null}
		</Tab>
	);
});
